/* global axios */
// Account is captured at entry; navigating cannot redirect a live session's requests.
export const callUrl = (accountId, roomId) =>
  `/api/v1/accounts/${accountId}/internal_communication/rooms/${roomId}/call`;

export const callRequest = async (url, action, data = {}) => {
  const response = await axios.post(`${url}/${action}`, data);
  return response.data;
};

export const callStatus = async url => (await axios.get(url)).data;
export const removeCallParticipant = (url, userId) =>
  axios.delete(`${url}/participants/${userId}`);
